import React, { memo } from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import InputField from "Components/formControls/HookFields/InputField";
import { useOrganizationValidation } from "Validations/Organization/useOrganizationValidation";

const LoginId = memo(() => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();
  const { information, disabledView } = watch();

  const { organizationNameError } = useOrganizationValidation();

  return (
    <InputField
      register={register("information.orgId", organizationNameError)}
      name="information.orgId"
      label={t("companySetup.information.orgId.label")}
      placeholder={t("companySetup.information.orgId.placeholder")}
      value={get(information, "orgId", "").trimLeft()}
      error={get(errors, "information.orgId.message", "")}
      disabled={disabledView}
    />
  );
});

export default LoginId;
